import { Component, EventEmitter, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { Box } from 'src/app/models/box';
import { BoxGroup } from 'src/app/models/box-group';
import { BoxGroupsService } from 'src/app/services/box-groups.service';
import { BoxesService } from 'src/app/services/boxes.service';
import { BoxGroupTreeComponent } from './box-group-tree-item/box-group-tree-item.component';

@Component({
    selector: 'app-boxes-tree',
    templateUrl: './boxes-tree.component.html',
    styleUrls: ['./boxes-tree.component.scss'],
    imports: [BoxGroupTreeComponent]
})
export class BoxesTreeComponent implements OnInit {
    public boxGroups: BoxGroup[];

    /**
     * Emis lorsque l'utilisateur clique sur le menu contextuel 'Editer' d'une bannette.
     */
    @Output()
    itemEdited: EventEmitter<Box> = new EventEmitter();

    /**
     * Emis lorsque l'utilisateur clique sur le menu contextuel 'dupliquer' d'une bannette.
     */
    @Output()
    itemDuplicated: EventEmitter<Box> = new EventEmitter();

    /**
     * Emis lorsque l'utilisateur clique sur le menu contextuel 'Consulter' d'une bannette.
     */
    @Output()
    itemDisplayed: EventEmitter<Box> = new EventEmitter();

    /**
     * Emis lorsque l'utilisateur clique sur le menu contextuel 'Supprimer' d'une bannette.
     */
    @Output()
    itemDeleted: EventEmitter<Box> = new EventEmitter();

    /**
     * Références aux composants correspondant aux noeuds groupe de bannettes de l'arbre.
     */
    @ViewChildren(BoxGroupTreeComponent) treeChildren: QueryList<BoxGroupTreeComponent>;

    /**
     * Constructeur.
     * @param groupsService Service pour gérer les groupes de bannettes.
     * @param boxService Service pour gérer les bannettes.
     */
    constructor(
        public boxGroupService: BoxGroupsService,
        public boxService: BoxesService
    ) {}

    /**
     * Initialise le composant.
     */
    ngOnInit(): void {
        // récupération des groupes de bannettes
        this.boxGroupService.List(null, null, null, null).subscribe((x) => {
            this.boxGroups = x.value;
        });
    }

    /**
     * Appellé lorsque l'utilisateur sélectionne 'Consulter' dans le menu contextuel d'une bannette.
     * @param box Bannette sélectionnée.
     */
    public onBoxDisplayed(box: Box) {
        this.itemDisplayed.emit(box);
    }

    /**
     * Appellé lorsque l'utilisateur sélectionne 'Editer' dans le menu contextuel d'une bannette.
     * @param user Bannette sélectionnée.
     */
    public onBoxEdited(box: Box) {
        this.itemEdited.emit(box);
    }

    /**
     * Appellé lorsque l'utilisateur sélectionne 'Dupliquer' dans le menu contextuel d'une bannette.
     * @param user Bannette sélectionnée.
     */
    public onBoxDuplicated(box: Box) {
        this.itemDuplicated.emit(box);
    }

    /**
     * Appellé lorsque l'utilisateur sélectionne 'Supprimer' dans le menu contextuel d'une bannette.
     * @param user Bannette sélectionnée.
     */
    public onBoxDeleted(box: Box) {
        this.itemDeleted.emit(box);
    }

    /**
     * Raffraichit l'affichage d'un groupe et de ses noeuds enfants.
     * @param boxGroupId : Identifiant du groupe de bannettes.
     */
    public refresh(boxGroupId: string) {
        this.treeChildren.toArray().forEach((item, index) => {
            item.refresh(boxGroupId);
        });
    }
}
